import React, { useContext, useRef } from "react";
import { getCSRFToken } from "tsi-common-react/src/utils/ajax";

import { Context, reverse } from "@reactivated";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import styles from "./index.module.scss";

export const SiteHeaderLanguageToggle = (): React.ReactNode => {
    const contex = useContext(Context);
    const currentLanguage = contex.i18n.language;
    const langPickerEntries = contex.settings.lang_picker;

    const formElem = useRef<HTMLFormElement | null>(null);
    const csrfInput = useRef<HTMLInputElement | null>(null);
    const langCodeInput = useRef<HTMLInputElement | null>(null);
    const nextURLInput = useRef<HTMLInputElement | null>(null);

    const nonCurrentLangs = langPickerEntries.filter((entry) => {
        return !(
            // Cover both vases of currentLanguage.code being just a
            // language (`en`) or a language and region (`en-us`)
            (
                entry.language_code == currentLanguage.code ||
                entry.language_code.startsWith(`${currentLanguage.code}-`)
            )
        );
    });

    const onLanguageChange = async (
        langCode: string,
        e: React.MouseEvent<HTMLAnchorElement>,
    ): Promise<void> => {
        if (
            !csrfInput.current ||
            !langCodeInput.current ||
            !nextURLInput.current ||
            !formElem.current
        ) {
            return;
        }
        e.preventDefault();
        const window = getWindow();
        if (!window) {
            return;
        }
        const nextURL = new URL(e.currentTarget.href, window.location.href);
        csrfInput.current.value = await getCSRFToken();
        langCodeInput.current.value = langCode;
        nextURLInput.current.value = nextURL.toString();
        formElem.current.submit();
    };

    return (
        <div>
            {nonCurrentLangs.map((entry) => (
                <a
                    rel="alternate"
                    key={entry.language_code}
                    href={entry.url}
                    hrefLang={entry.language_code}
                    className={styles.button}
                    onClick={onLanguageChange.bind(
                        undefined,
                        entry.language_code,
                    )}
                >
                    {entry.locale_autonym}
                </a>
            ))}
            <form ref={formElem} method="POST" action={reverse("set_language")}>
                <input
                    ref={csrfInput}
                    type="hidden"
                    name="csrfmiddlewaretoken"
                />
                <input ref={langCodeInput} type="hidden" name="language" />
                <input ref={nextURLInput} type="hidden" name="next" />
            </form>
        </div>
    );
};
